/**
 * Generates a RFC4122 version 4 compliant UUID
 * Uses crypto.getRandomValues when available, falls back to Math.random
 * @returns {string} A random UUID
 */
export function generateGuid() {
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    // Use cryptographically strong random values
    return '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
  }
  
  // Fallback to Math.random (less secure)
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}